import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";

import { vsObjectName as machineName } from "../../configs/machine";
import { vsObjectName as gamingContractName } from "./gamingContract";

export const vsObjectName = "gamingContractMachine";

export const vsMachineColumnSetName = `${vsObjectName}.machine`;
export const vsContractColumnSetName = `${vsObjectName}.contract`;

gamingContractMachineConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function gamingContractMachineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsMachineColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(machineName) ?? [],
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsContractColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(gamingContractName) ??
        [],
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) => [
      ...(columnDefinitionSetService.getColumnDefinitionSet(
        gamingContractName
      ) ?? []),
      ...(columnDefinitionSetService.getColumnDefinitionSet(machineName) ?? []),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ): GridConfiguration => {
      return {
        defaultSort: "SerialNumber,ContractNumber",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/contract/machines"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Contract Machines",
        nameSingular: "Contract Machine",
        showAddButton: false,
        columnDefinitionSet: vsObjectName,
      };
    },
  ]);
}
